import Dialog from "@/components/Dialog";
import Button from "@/components/Button";
import { Event } from "../../../types";

interface Props {
  event: Event;
  open: boolean;
  onClose: () => void;
}

export default function MissingAddressesModal({ event, open, onClose }: Props) {
  const missingExaminerAddress = !event.patEventAttributes?.examiner?.contactAddress;
  const missingHostAddress = !event.patEventAttributes?.hostProfessional?.contactAddress;

  const missingAddressesCopy = [
    missingHostAddress ? "Event Host" : null,
    missingExaminerAddress ? "PAT Examiner" : null
  ]
    .filter(Boolean)
    .join(" and ");

  return (
    <Dialog
      open={open}
      actions={<Button onClick={() => onClose()}>Go Back</Button>}
      headline="Submit for Payment"
      onClosed={onClose}
    >
      {missingHostAddress && (
        <div className="text-label-large" data-testid="missing-host-address">
          Missing Event Host Address
        </div>
      )}
      {missingExaminerAddress && (
        <div className="text-label-large" data-testid="missing-examiner-address">
          Missing PAT Examiner Address
        </div>
      )}
      <p className="mt-6">
        Please provide an address for the {missingAddressesCopy} in their profile so payment can be processed properly.
      </p>
    </Dialog>
  );
}
